// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1z6WL","unreadBadge":"styles_unreadBadge__1sksi","modalContent":"styles_modalContent__1KHSn","modal":"styles_modal__2r9hA"};